import { DefaultCarPageComponentProps } from "@/app/interface/components";
import { getVehicleDiferentials } from "@/app/utils/vehiclesInfo";
import DifferentialItem from "./DifferentialItem";

const DifferentialsSection = ({
  car,
  model,
  version,
}: DefaultCarPageComponentProps) => {
  const info = getVehicleDiferentials(
    car?.name?.toLocaleLowerCase()?.replaceAll(" ", "-")!,
    model?.name!,
    version?.name!
  );
  const differentialsData = [
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_design.svg",
      title: "Design",
      description: info?.design,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_tecnologia.svg",
      title: "Tecnologia",
      description: info?.tecnologia,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_performance.svg",
      title: "Performance",
      description: info?.performance,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_seguranca.svg",
      title: "Segurança",
      description: info?.seguranca,
    },
  ];
  return (
    <section className="flex z-0 flex-col justify-center pb-8 mt-16 max-w-full w-[1140px] max-md:mt-10 mx-auto">
      <div className="flex flex-wrap gap-4 justify-center items-start w-full max-md:max-w-full">
        {differentialsData.map((differential, index) => (
          <DifferentialItem
            key={differential.iconSrc + index}
            iconSrc={differential.iconSrc}
            title={differential.title}
            description={differential.description!}
          />
        ))}
      </div>
    </section>
  );
};

export default DifferentialsSection;
